'use client';

import { NavigationCross } from '@energy-retailer/icons';
import { Dialog } from '@headlessui/react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { Text } from '@/components/text';

import { ContentfulIcon } from '../icon';

import { useModal } from './context';

import type { ReactNode } from 'react';

export const ModalHeader = ({
  description,
  expandHeader = false,
  heading,
  icon,
  headingStyle,
  iconStyle,
}: {
  description?: ReactNode;
  expandHeader?: boolean;
  heading: string;
  icon?: string;
  headingStyle?: string;
  iconStyle?: string;
}) => {
  const { closeModal } = useModal();

  return (
    <div
      className={twMerge(
        clsx(
          'flex flex-col gap-a border-b border-b-gray-300 px-e py-d md:py-c lg:px-d lg:py-b',
          {
            'flex-1': expandHeader,
          },
          headingStyle
        )
      )}
    >
      <div className="flex items-center justify-between">
        <Dialog.Title
          as="div"
          className="flex gap-a"
        >
          {icon ? (
            <ContentfulIcon
              id={icon}
              className={twMerge(
                clsx(
                  'h-e w-e cursor-pointer text-pink-500 md:h-d md:w-d lg:h-c lg:w-c',
                  iconStyle
                )
              )}
            />
          ) : null}
          <Text
            variant="h3"
            as="h3"
            className="leading-none"
          >
            {heading}
          </Text>
        </Dialog.Title>
        {closeModal ? (
          <NavigationCross
            className="h-e w-e cursor-pointer md:h-d md:w-d lg:h-c lg:w-c"
            onClick={closeModal}
          />
        ) : null}
      </div>
      {description ? (
        <Dialog.Description as="div">
          <Text
            className="text-[1rem]"
            as="p"
          >
            {description}
          </Text>
        </Dialog.Description>
      ) : null}
    </div>
  );
};
